import { get } from 'api';

import { CROPS_LOADED, LOAD_CROPS, RESET_CROPS, SYNC_FAILED } from './actionTypes';
import type { IAgronomyAgreementCropsActions } from './types';

export const initialActionsState: IAgronomyAgreementCropsActions = {
  loadCrops: () => {},
  resetCrops: () => {},
};

export const getActions = (dispatch: (value: { type: string; payload?: any }) => void) => ({
  loadCrops: async () => {
    dispatch({ type: LOAD_CROPS });

    const { data, error } = await get('/agronomy-agreements/crops');

    if (error) {
      dispatch({ type: SYNC_FAILED, payload: error });
    } else {
      dispatch({ type: CROPS_LOADED, payload: { data: Array.isArray(data) ? data : [] } });
    }
  },

  resetCrops: () => dispatch({ type: RESET_CROPS }),
});
